module.exports = __webpack_public_path__ + "static/images/7279462433f734ac217a189630f9369a.png";